<div #aboutPage data-section-id="about-page-section" data-section-name="About Page">
  <app-hero-banner></app-hero-banner>
  <app-benefits-requirements></app-benefits-requirements>
  <app-info-adicional></app-info-adicional>
  <app-attention-channels></app-attention-channels>
  <app-contact-support></app-contact-support>
  <app-cta-banner></app-cta-banner>
</div>

<!-- Botones flotantes reutilizables -->
<app-floating-buttons></app-floating-buttons>

